/**
 * Build-time site-variant gate.
 *
 * The videxa-poc marketing re-skin must only ship to the DEV app
 * (dev.videxa.ai) until the owner explicitly promotes it to production.
 * Because the agentnexus repo has a single pipeline where every merge to
 * `main` runs both `build-and-deploy-dev` AND `deploy-prod`, we cannot gate
 * the re-skin by environment at runtime — CRA bakes `REACT_APP_*` values in
 * at `docker build` time, not at runtime.
 *
 * Instead the dev image is built with `REACT_APP_SITE_VARIANT=reskin`
 * (see the build-and-deploy-dev job in .github/workflows/ci.yml and the
 * local build scripts). The prod image never sets it, so the production
 * bundle renders exactly the current/legacy site.
 *
 * CONTRACT: when the variable is unset OR any value other than the exact
 * string "reskin", the app renders the legacy production site. Only the
 * literal "reskin" opts a build into the new marketing site.
 */
export const SITE_VARIANT = process.env.REACT_APP_SITE_VARIANT || '';

export const RESKIN_VARIANT = 'reskin';

/**
 * True only when this build was compiled with REACT_APP_SITE_VARIANT=reskin.
 * Use this to select between legacy and re-skin components/routes.
 */
export const isReskin = SITE_VARIANT === RESKIN_VARIANT;

export default isReskin;
